import { render, staticRenderFns } from "./SafetyConfirmOtherUsersModal.vue?vue&type=template&id=c92f18f4&lang=pug"
import script from "./SafetyConfirmOtherUsersModal.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmOtherUsersModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports